import AddUserModalError from './component'

export default AddUserModalError
